angular.module('account.roles.add', [
  'security.authorization',
  'services.utility',
  'services.adminResource',
  'directives.serverError',
  'resources.Role',
  'ui.bootstrap.dropdown',
  'services.formErrors',
  'ngFileUpload',
])

.config(["$stateProvider", function ($stateProvider) {
  $stateProvider
  .state('account.roles.add', {
    url: '/add',
    title: 'Account Roles / Details',
    views: {
      'main@': {
        template: require('./role-add.tpl.html'),
        controller: 'AccountRoleAddCtrl'
      }
    },
    resolve: {
      user: ["User", "$state", "$location", function (User, $state, $location) {

        return User.current(function (user) {
          if (user && user.is_active && user.permissions.is_admin || user.permissions.is_editor) {
            return user;
          }
          return $state.go('unauthorized');
        }).$promise;
      }],
    }
  });
}])

.controller('AccountRoleAddCtrl',
  ["$scope", "$route", "$location", "$log", "utility", "adminResource", "Role", "formErrors", "growl", "dateFilter", "Upload", function ($scope, $route, $location, $log, utility, adminResource, Role, formErrors, growl, dateFilter, Upload) {
    var slugify = function (text) {
      if (typeof text !== 'string') return text;
      return text.toString()
      .toLowerCase()
      .replace(/á/g, 'a')
      .replace(/é/g, 'e')
      .replace(/í/g, 'i')
      .replace(/ó/g, 'o')
      .replace(/ú/g, 'u')
      .replace(/ã/g, 'a')
      .replace(/ñ/g, 'n')
      .replace(/ç/g, 'c')
      .replace(/ü/g, 'u')
      .replace(/^\s+|\s+$/g, "")
      .replace(/[_|\s]+/g, "-")
      .replace(/[^a-z\u0400-\u04FF0-9-]+/g, "")
      .replace(/[-]+/g, "-")
      .replace(/^-+|-+$/g, "");
    };
    $scope.dataLoaded = true;
    $scope.roleTypesList = [];
    $scope.languagesList = [];
    $scope.data = {
      name: null,
      //sport: null,
      type: null
    }

    $scope.role = {
      name: "",
      //sport: "",
      type: ""
    }

    adminResource.getRoleTypes().then(function (types) {
      $scope.roleTypesList = types;
    })

    /*adminResource.getSports().then(function (sports) {
      $scope.sportsList = sports && sports.data ? sports.data : [];
    })*/

    adminResource.getLanguages().then(function (languages) {
      $scope.languagesList = languages;
    })

    $scope.addTranslation = function ($event) {
      $event.preventDefault()
      var translation = {
        name: "",
        languageTag: ""
      }
      if (!$scope.role.translations) {
        $scope.role.translations = [];
      }
      $scope.role.translations.push(translation);
    };

    $scope.removeTranslation = function (index, $event) {
      $event.preventDefault()
      $scope.role.translations.splice(index, 1);
    };

    $scope.submit = function () {
      var data = angular.copy($scope.role);

      $scope.dataLoaded = false;
      Role.save(data, function (result) {
        $scope.dataLoaded = true;
        growl.info('Role saved!');
        $location.path('/account/roles/edit/' + result._id);
      }, function (error) {
        formErrors.growlErrors(error);
        $scope.dataLoaded = true;
      });

    };


  }]);



// WEBPACK FOOTER //
// ./client/src/app/account/roles/role-add.js